import { PropsWithChildren, useEffect, useRef, useState } from "react"
import MarkunreadOutlinedIcon from '@mui/icons-material/MarkunreadOutlined';
import { useLocation, useNavigate } from "react-router-dom";
import { RecentChatsModal } from "../chat/RecentChatsModal";
import useClickOutsideRef from "../hooks/useClickOutsideRef";
import InboxTooltip from "../common/InboxNotificationTooltip";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {InboxNotificationType, setUnseenNotificationsCount} from "../../store/features/inboxSlice";
import { SecondaryButton } from "../buttons/SecondaryButton";
import {getUnreadNotificationsCount} from "../../api/requests/notifications";

export interface NotificationsButtonProps extends PropsWithChildren {
}

export const NotificationsButton: React.FC<NotificationsButtonProps> = (props) => {

    const buttonRef = useRef<HTMLDivElement>(null);

    const [unreadNotification, setUnreadNotification] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const location = useLocation();

    const inboxState = useAppSelector((state) => state.inbox);
    const buttonRef2 = useRef<any>(null);
    const [showTooltip, setShowTooltip] = useState(true);

    const isModalOpen = useClickOutsideRef(buttonRef, modalOpen, ["notification-button"], false, buttonRef2);

    const [unreadNotificationsAmount, setUnreadNotificationsAmount] = useState(0);

    const dummyNotifData = {
        notificationId: 12,
        chatChannelId: 12,
        type: InboxNotificationType.RENTAL_REQUESTED,
        productName: "string",
        createdDate: "12/21",
        senderProfilePicUrl: "string",
        senderName: "Jaanus Meidla"
    }

    useEffect(() => {
        updateUnseenNotificationsCount();
    }, []);

    const updateUnseenNotificationsCount = async () => {
        const count = await getUnreadNotificationsCount();
        dispatch(setUnseenNotificationsCount(count));
    }

    const handleCloseOption = () => {
        setModalOpen(false)
    }

    const handleUnreadNotifAmount = (notifAmount: number) => {
        // setUnreadNotificationsAmount(notifAmount);
      };

    return (

        <div ref={buttonRef} onClick={() => { setUnreadNotification(false); handleCloseOption() }} className="group relative cursor-pointer p-2 z-30">
            <InboxTooltip
                targetRef={buttonRef2}
                content="This is a tooltip"
                visible={showTooltip}
                notificationData={inboxState.incomingNotification}
            />
            <div>
                <div ref={buttonRef2} className="notification-button">
                    <MarkunreadOutlinedIcon />
                </div>
                <div className={`${inboxState.unSeenNotifictions > 0 ? "flex" : 
                    "hidden"} flex absolute top-2 right-1 justify-center items-center bg-primary rounded-[50%] w-[15px] h-[15px] text-white text-[10px]`}>
                    {inboxState.unSeenNotifictions}
                </div>
            </div>

            <div className="z-[-1] group-hover:h-[110%] group-hover:w-[110%] absolute left-1/2 top-1/2 translate-x-[-50%] translate-y-[-50%] bg-primary_light rounded-full h-0 w-0 transition-all duration-200"></div>

            {isModalOpen ? <RecentChatsModal handleUnreadNotifAmount={handleUnreadNotifAmount}/> : ""}

        </div>
    )
}